import React from "react";
import PropTypes from "prop-types";

import rss from "./svg/rss-lg.svg";
import linkedin from "./svg/social-linkedin-lg.svg";
import github from "./svg/social-github-lg.svg";
import medium from "./svg/social-medium-lg.svg";
import twitter from "./svg/social-twitter-lg.svg";

import "./icons.css";

const extractHandle = url => {
    const parts = url.split("/");

    return parts[parts.length - 1];
  },
  SocialIcons = ({ social }) => <ul className="iconic-container">
      <li>
        <a href="/rss.xml">
          <img data-type="rss" src={rss} className="iconic" alt="rss" />
        </a>
      </li>
      <li>
        <a href={social.linkedin}>
          <img
            data-type="linkedin"
            src={linkedin}
            className="iconic"
            alt="linkedin"
          />
        </a>
      </li>
      <li>
        <a href={social.twitter}>
          <img
            data-type="twitter"
            src={twitter}
            className="iconic"
            alt="twitter"
          />
          <span>{extractHandle(social.twitter)}</span>
        </a>
      </li>
      <li>
        <a href={social.github}>
          <img
            data-type="github"
            src={github}
            className="iconic"
            alt="github"
          />
          <span>{extractHandle(social.github)}</span>
        </a>
      </li>
      <li>
        <a href={social.medium}>
          <img
            data-type="medium"
            src={medium}
            className="iconic"
            alt="medium"
          />
          <span>{extractHandle(social.medium)}</span>
        </a>
      </li>
    </ul>;

SocialIcons.propTypes = {
  social: PropTypes.shape({
    twitter: PropTypes.string.isRequired,
    linkedin: PropTypes.string.isRequired,
    medium: PropTypes.string,
    github: PropTypes.string.isRequired
  })
};
export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/SocialIcons/index.jsx